import React, { Fragment, useEffect, useState } from "react";
import "../../../styles/common.css";
import { Outlet } from "react-router-dom";
import SideMenu from "./side-menu.jsx";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import { catchError } from '../../helpers/catch-error.jsx';
import logo from '../../../assets/images/logo-round.jpeg'


const Layout = () => {
    const navigate = useNavigate();
    const [isMini, setIsMini] = useState(false);

    useEffect(() => {
        document.title = process.env.REACT_APP_NAME + ": guestistrator";
        console.log(localStorage.getItem('@user_email'));
        console.log(localStorage.getItem('@user_role'));

        if (!(localStorage.getItem('@user_email') && localStorage.getItem('@user_role') && localStorage.getItem('@user_role') > 1)) {
            localStorage.removeItem("@name");
            localStorage.removeItem("@user_role");
            localStorage.removeItem("@user_email");
            navigate("/login");
        }


    }, []);
  

    return (
        <Fragment>
            <div className={isMini ? "layout-fixed sidebar-expand-lg sidebar-mini sidebar-collapse bg-body-tertiary" : "layout-fixed sidebar-expand-lg sidebar-mini sidebar-open bg-body-tertiary"}>
             
                    <Outlet />

            </div>




        </Fragment>
    );
};

export default Layout;
